module.exports = __webpack_public_path__ + "static/media/icon-clip-white.442e0b68.svg";